var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabStats = function SvgTabStats(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3765",
    width: 2,
    height: 28,
    y: 4,
    ry: 0.875
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect3767",
    width: 2,
    height: 32,
    x: 30,
    y: -32,
    ry: 1,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3771",
    d: "m29 8-7 5-5-1-4 4-5-6-4 4v6.563l3.281-3.282.781-.75.72.844 4.28 5.125 3.594-3.594.531.125 4.563.907L29 14.78zm0 9.219-6.406 4.594-.375.25-.406-.094-4.438-.906-3.656 3.656-.781.75-.72-.844-4.28-5.125L4 23.438V28h25z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabStats);
export default ForwardRef;